export default __webpack_public_path__ + "static/media/CETOWhitepaper1.5.30eb9382.pdf";